var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { getRouterBasename } from '../helpers/path';
import { parseDataSet } from './../helpers/sanitize';
import { camelCase } from 'lodash-es';
import { createInertiaApp } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import ErrorBoundary from './components/ErrorBoundary';
import './sentry';
import './bootstrap';
window.addEventListener('DOMContentLoaded', function () {
    const reactComponents = document.querySelectorAll('[data-react-component]');
    if (reactComponents) {
        reactComponents.forEach((reactComponentElement) => {
            if (!(reactComponentElement instanceof HTMLElement)) {
                return;
            }
            const dataset = parseDataSet(Object.assign({}, reactComponentElement.dataset));
            const data = {};
            Object.keys(dataset).forEach((key) => {
                data[camelCase(key)] = dataset[key];
            });
            const _a = Object.assign({ reactComponent: null }, data), { reactComponent = null } = _a, props = __rest(_a, ["reactComponent"]);
            if (!reactComponent) {
                console.log('reactComponent not provided');
                return;
            }
            const ComponentToRender = lazy(() => {
                return import(`./Blade/${reactComponent}`);
            });
            if (ComponentToRender) {
                render(_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { basename: getRouterBasename(), children: _jsx(ErrorBoundary, { children: _jsx(Suspense, { fallback: null, children: _jsx(ComponentToRender, Object.assign({}, props)) }) }) }) }), reactComponentElement);
            }
        });
    }
});
if (document.getElementById('inertia-app')) {
    InertiaProgress.init();
    createInertiaApp({
        id: 'inertia-app',
        resolve: (name) => {
            return import(`./Pages/${name}`);
        },
        setup({ el, App, props }) {
            render(_jsx(Provider, { store: store, children: _jsx(App, Object.assign({}, props)) }), el);
        },
    });
}
